import { BaseContainerModel } from '../../base-container.model';
import { bl_b2b_xtn_einvoice_matched_history_RowClass } from '../../../dbschema/index';

export class XtnEinvoiceMatchedHistoryContainer extends BaseContainerModel {
  bl_b2b_xtn_einvoice_matched_history: bl_b2b_xtn_einvoice_matched_history_RowClass = new bl_b2b_xtn_einvoice_matched_history_RowClass();
}
